import { render, staticRenderFns } from "./PatientRecord.vue?vue&type=template&id=6c432573&scoped=true"
import script from "./PatientRecord.vue?vue&type=script&lang=js"
export * from "./PatientRecord.vue?vue&type=script&lang=js"
import style0 from "./PatientRecord.vue?vue&type=style&index=0&id=6c432573&prod&scoped=true&lang=css"
import style1 from "./PatientRecord.vue?vue&type=style&index=1&id=6c432573&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c432573",
  null
  
)

export default component.exports